import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

/**
 * What only a client-simulated challenge has to edit: the Drive id students paste
 * into startup.json and a Drive link to the exploration data. The encrypted maze file
 * itself is not editable -- its md5 is checked against every recording.
 */
export function ClientEditFields({
  mazeId,
  explorationDataUrl,
  onMazeId,
  onExplorationDataUrl,
}: {
  mazeId: string;
  explorationDataUrl: string;
  onMazeId: (value: string) => void;
  onExplorationDataUrl: (value: string) => void;
}) {
  return (
    <div className="grid gap-4 rounded-md border p-3">
      <p className="text-xs font-medium">Student's machine</p>
      <div className="grid gap-2">
        <Label htmlFor="e-maze-id">Maze Drive file id</Label>
        <Input
          id="e-maze-id"
          value={mazeId}
          onChange={(e) => onMazeId(e.target.value)}
          className="font-mono text-xs"
        />
        <p className="text-muted-foreground text-xs">
          Goes into students' startup.json. The encrypted maze file it points at is fixed:
          every recording is checked against its md5, so a different maze is a new
          challenge.
        </p>
      </div>
      <div className="grid gap-2">
        <Label htmlFor="e-data">Exploration dataset URL</Label>
        <Input
          id="e-data"
          value={explorationDataUrl}
          onChange={(e) => onExplorationDataUrl(e.target.value)}
        />
      </div>
      <p className="text-muted-foreground text-xs">
        Runs happen on the student's machine, so there are no session limits or motion
        noise to set. Where a challenge runs is fixed when it is created.
      </p>
    </div>
  );
}
